// No Firebase imports needed - compatibility handled in parent class
import { FirestoreTournamentRepository } from "./FirestoreTournamentRepository.js";
export class LocalTournamentRepository extends FirestoreTournamentRepository {
}
